import React from 'react';
import PropTypes from 'prop-types';
import injectSheet from 'react-jss';
import cn from 'classnames';
import theme, { buttonReset, sliceColourTheme } from '../../styles/theme';
import { colourThemeType } from '../../propTypes';

const svgViewBox = '0 0 7.1 12.7';

const getArrowPathProps = (direction, vertical) => {
  let arrowRotation = 0;
  if (direction === 'prev') {
    if (vertical) {
      // base svg is →
      arrowRotation = -90;
    } else {
      // left
      arrowRotation = 180;
    }
  } else if (vertical) {
    // down
    arrowRotation = 90;
  }
  return {
    transform: `rotate(${arrowRotation} ${svgViewBox.split(' ')[2] / 2} ${svgViewBox.split(' ')[3] / 2})`,
  };
};

const getArrowColour = (disabled, buttonColor, colourTheme) => (disabled
  ? theme.colors.inactiveBtn : buttonColor || colourTheme.textColour);

const Button = ({
  classes, className, direction, disabled,
  disabledClassName, onClick, vertical,
  buttonColor, colourTheme,
}) => (
  <button
    className={cn(
      className,
      classes.button,
      disabled && classes.disabled,
      disabled && disabledClassName,
      // Temporary class for styling Our Story disabled chevron
      { disabledChevron: disabled },
    )}
    type="button"
    onClick={onClick}
  >
    <svg className={classes.arrow} viewBox={svgViewBox}>
      <polygon {...getArrowPathProps(direction, vertical)} fill={getArrowColour(disabled, buttonColor, colourTheme)} strokeWidth={0.5} stroke={getArrowColour(disabled, buttonColor, colourTheme)} points="0.7,12.7 0,12 5.7,6.3 0,0.7 0.7,0 7.1,6.3 " />
    </svg>
  </button>
);

Button.propTypes = {
  classes: PropTypes.objectOf(PropTypes.string).isRequired,
  className: PropTypes.string,
  disabledClassName: PropTypes.string,
  direction: PropTypes.oneOf(['prev', 'next']).isRequired,
  disabled: PropTypes.bool,
  onClick: PropTypes.func,
  vertical: PropTypes.bool,
  buttonColor: PropTypes.string,
  colourTheme: colourThemeType,
};

Button.defaultProps = {
  className: undefined,
  disabled: false,
  disabledClassName: undefined,
  onClick: undefined,
  vertical: false,
  buttonColor: undefined,
  colourTheme: sliceColourTheme.white,
};

export default injectSheet({
  button: {
    extend: [
      buttonReset({
        borderRadius: '50%',
        width: 32,
        height: 32,
        padding: 0,
        transition: 'box-shadow 0.3s ease-in-out, opacity 0.3s ease-out',
      }), {
        cursor: 'pointer',
        zIndex: 10,
      },
    ],
    '& svg polygon': {
      transition: 'all 0.3s',
    },
  },
  disabled: {
    pointerEvents: 'none',
  },
  arrow: ({ vertical }) => ({
    display: 'block',
    margin: 'auto',
    width: !vertical ? 8 : 28,
    height: !vertical ? 14 : 16,
  }),
})(Button);
